import { FunctionComponent } from 'preact';

import { IconButton, IconButtonProps } from '../IconButton/IconButton';
import { useCaptions } from '../../hooks/useCaptions';
import { useIcons } from '../../hooks/useIcons';

export const CaptionsButton: FunctionComponent<IconButtonProps> = (props) => {
  const { captionsList } = useCaptions();
  const { Subtitles } = useIcons();

  const hasCaptions = captionsList.length > 1;

  if (!hasCaptions) {
    return null;
  }

  return (
    <IconButton {...props}>
      <Subtitles />
    </IconButton>
  );
};
